import ordersubtno from './ordersubtno'
import jyorder from './jyorder'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    ordersubtno,
    jyorder,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/jyb/index.js